// extracted by mini-css-extract-plugin
export default {"loading":"home_loading__LO+RN","pcWrap":"home_pcWrap__ROWNu","footer":"home_footer__vriku","footerGap":"home_footerGap__eQo5h"};